/**
 * Türkçe çeviri sözlüğü — MACDM SPA için tek doğruluk kaynağı.
 * Anahtarlar derlemede tipli olarak doğrulanır (bkz. ./index.ts).
 * Kayıt deseni: nokta-ayrılmış, küçük harf, alan-eylem (ör. "setup.queryLabel").
 */
export const tr = {
  app: {
    title: "Konsey",
    brand: "Karar Zekası v2",
    tagline: "Kanıt destekli kurumsal karar platformu.",
  },
  status: {
    draft: "Taslak",
    provisioning: "Hazırlanıyor",
    running: "Tartışıyor",
    interrupted: "Kesildi",
    finalized: "Sonuçlandı",
    error: "Hata",
    dev: "Geliştirici",
  },
  header: {
    start: "Tartışmayı Başlat",
    stop: "Tartışmayı Durdur",
    pivot: "Pivot iste",
    pivotPlaceholder: "Pivot yönergesi — moderatöre yön ver",
    pivotSend: "Gönder",
    settings: "Ayarlar",
    toggleTheme: "Temayı değiştir",
    toggleMute: "Sesi kıs",
    keyboardHelp: "Klavye kısayolları",
    roundShort: "TUR",
    of: "/",
  },
  setup: {
    sectionTitle: "Tartışma Kurulumu",
    queryLabel: "Stratejik Soru",
    queryPlaceholder:
      "Örn. C4ISR modernizasyonunda milli taktik veri bağı mı, NATO uyumlu hazır çözüm mü öncelikli olmalı?",
    queryHelpMin: "En az {min} karakter gerekli.",
    queryHelpMax: "{count} / {max} karakter",
    queryShortcut: "Hızlı başlat: Ctrl/Cmd + Enter",
    queryExamplesTitle: "Önerilen örnekler",
    topologyTitle: "Tartışma Topolojisi",
    topologyHint:
      "Konseyin nasıl konuşacağını seçin. Her topoloji farklı bir bilişsel akış üretir.",
    topology: {
      "round-robin": {
        label: "Sıralı Söz",
        tagline: "Saat yönünde eşit söz hakkı.",
        bestFor: "Geniş kapsamlı keşif ve dengeli görüş toplama için.",
      },
      "cross-fire": {
        label: "Çapraz Düello",
        tagline: "İki uzman karşılıklı; moderatör hakem.",
        bestFor: "İki kutuplu ikilemleri keskinleştirmek için.",
      },
      "moderator-led": {
        label: "Moderatör Önderliğinde",
        tagline: "Yıldız topoloji: moderatör → uzman → moderatör.",
        bestFor: "Yapılandırılmış denetim ve ardışık derinleşme için.",
      },
      "diverse-poles": {
        label: "Çelişki-Maks (Karşı Kutup)",
        tagline:
          "1. Tur: her uzmana zorunlu zıt kutup. Sonraki turlar: çapraz tartışma.",
        bestFor:
          "Tutucu sezgileri kırıp çözüm uzayını gerçekten taramak için (Demystifying MAD 2026 — +%21,5 MathQA).",
      },
      "solo-then-debate": {
        label: "Önce Solo → Sonra Tartış",
        tagline:
          "1. Tur: bağımsız tekil cevap. Yeterli mutabakat varsa tartışma atlanır.",
        bestFor:
          "Token tasarrufu — kolay sorularda ~6× verimlilik (DOWN makalesi 2025).",
      },
      investigation: {
        label: "Kapsam-Güdümlü Soruşturma",
        tagline:
          "Sırayla değil BOŞLUĞA göre konuşur — soruda adı geçen her aktör bir hücre defterinde takip edilir.",
        bestFor:
          "Kişi/kurum soruşturması, brifing ve derin analiz — adı geçen aktörlerin kaçmasını yapısal olarak önler.",
      },
    },
    councilTitle: "Konsey Önizlemesi",
    councilHint: "Sorunuza göre toplanacak konsey üyeleri.",
    councilEmpty: "Soruyu yazmaya başlayın; konsey burada şekillenecek.",
    quality: {
      title: "Soru Kalitesi",
      method:
        "İki bağımsız değerlendirici + gerçek işleme hattı sondası — tek modelin kendini puanlaması değil.",
      idleHint:
        "Belirsiz bir soru belirsiz bir tartışma değil, hiçbir şey hakkında kendinden emin bir tartışma üretir. Başlamadan önce ölçelim.",
      assess: "Soruyu Değerlendir",
      reassess: "Yeniden Ölç",
      retry: "Tekrar Dene",
      assessing: "Soru değerlendiriliyor…",
      assessingHint: "İki değerlendirici paralel çalışıyor; birkaç saniye sürer.",
      scoreAria: "Soru kalite puanı",
      verdictReady: "Tartışmaya Hazır",
      verdictImprovable: "Geliştirilebilir",
      verdictVague: "Fazla Belirsiz",
      pipelineTitle: "İşleme hattı",
      probeRequirements: "gereksinim",
      probeEntities: "varlık",
      probeConstraints: "kısıt",
      probeAgreement: "mutabakat",
      missingTitle: "Eksik:",
      questionsTitle: "Netleştirelim — şık seç ya da kendin yaz",
      otherPlaceholder: "Diğer — kendi yanıtını yaz",
      otherAria: "Diğer (serbest metin)",
      skip: "Yine de devam et",
      rewrite: "Soruyu Yeniden Yaz",
      rewriting: "Yazılıyor…",
      proposalTitle: "Önerilen soru",
      proposalApply: "Uygula",
      proposalDiscard: "Vazgeç",
      assumptionsTitle: "Varsayıldı:",
      blockedToast:
        "Soru fazla belirsiz. Netleştir ya da «Yine de devam et» ile geç.",
    },
  },
  stage: {
    label: "Yuvarlak Masa",
    waitingNoQuery: "Stratejik soruyu yazın",
    waitingReady: "Konsey hazır — Tartışmayı Başlat'a basın.",
    activeRound: "TUR {n} / {max}",
    silent: "Sessizlik",
    speaking: "Konuşuyor",
    retrieving: "Veri taranıyor…",
    researching: "İnternet taranıyor",
    critiquing: "Kritik hazırlanıyor…",
    forfeit: "Pas geçti",
  },
  transcript: {
    title: "Canlı Transkript",
    empty: "Transkript burada belirecek. Tartışmayı başlattığınızda her tur kart olarak akacak.",
    turnsCount: "{n} sıra",
    forfeitedNote:
      "Bu turda yeni bir kritik üretilmedi — pas geçildi.",
    forfeitedReason: "({reason})",
  },
  moderator: {
    title: "Moderatör Paneli",
    consensusLabel: "Konsensüs",
    consensusPending: "Konsensüs sentezleniyor…",
    deadlock: "Deadlock",
    roundLabel: "Tur",
    interrupt: "Pivot iste",
    pivotOverlayTitle: "Moderator pivotu",
  },
  verdict: {
    title: "Konsey Kararı",
    placeholderTitle: "Karar henüz hazır değil",
    placeholderBody:
      "Tartışma sonlandığında konsey kararı, muhalefet şerhi ve eylem planı burada belirir.",
    placeholderHint: "Tartışmayı başlatmak için sol panelden bir topoloji seçin.",
    tabs: {
      summary: "Yönetici Özeti",
      dissent: "Muhalefet Şerhi",
      plan: "Eylem Planı",
    },
    summary: {
      meta: "{rounds} turda sentezlendi · konsensüs %{score}",
    },
    dissent: {
      empty: "Konsey tam mutabakata vardı; muhalefet kaydı yok.",
    },
    plan: {
      tiers: {
        immediate: "Acil",
        tactical: "Taktik",
        strategic: "Stratejik",
        architectural: "Mimari",
        governance: "Yönetişim",
      },
      subtitles: {
        immediate: "0-2 hafta · acil müdahale",
        tactical: "2-12 hafta · sprint ölçeği",
        strategic: "3-12 ay · program kararları",
        architectural: "12-36 ay · platform/mimari",
        governance: "Sürekli · karar hakları & RACI",
      },
      empty: "Bu kademede aksiyon yok.",
      risks: "Risk Register",
      kpis: "Yürütme KPI'ları",
      assumptions: "Kritik Varsayımlar",
      noMetric: "Ölçüt belirtilmemiş",
      legendOwner: "Sahip",
      legendDeadline: "Hedef",
      priority: {
        P0: "Engelleyici (P0)",
        P1: "Olmalı (P1)",
        P2: "İyi olur (P2)",
      },
      effort: {
        XS: "≤ 1 gün",
        S: "1-3 gün",
        M: "1-2 hafta",
        L: "2-6 hafta",
        XL: "> 6 hafta",
      },
    },
    export: {
      copyMd: "Markdown kopyala",
      downloadJson: "JSON indir",
      copied: "Markdown panoya kopyalandı.",
    },
  },
  errors: {
    streamFailed: "Akış başarısız oldu: {message}",
    cancelled: "Tartışma iptal edildi.",
  },
  examples: {
    e1: "Kara platformları için görev bilgisayarında yerli FPGA tabanlı mimariye geçmeli miyiz?",
    e2: "C4ISR modernizasyonunda Link-16 uyumluluğu mu, milli taktik veri bağı mı öncelikli olmalı?",
    e3: "İHA görev planlama yazılımında otonomi seviyesini artırmanın sertifikasyon ve emniyet riskleri neler?",
    e4: "Elektronik harp podu tedarikinde hazır yabancı çözüm mü, yerli geliştirme programı mı daha doğru?",
  },
} as const;

export type Dictionary = typeof tr;
